import { render, staticRenderFns } from "./Editors.vue?vue&type=template&id=68619004&scoped=true"
import script from "./Editors.vue?vue&type=script&lang=js"
export * from "./Editors.vue?vue&type=script&lang=js"
import style0 from "./Editors.vue?vue&type=style&index=0&id=68619004&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68619004",
  null
  
)

export default component.exports